import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import Watermark from '../modules/print/watermark/WatermarkComponent';

const PrintContext = React.createContext(false);

export const PrintProvider = PrintContext.Provider;

export const PrintConsumer = PrintContext.Consumer;

export const PrintableApp = withRouter(({ children, location }) => {
    const [isPrintMode] = useState(location.pathname.startsWith('/print'));

    useEffect(() => {
        if (isPrintMode) {
            const iframes = document.getElementsByTagName('iframe');

            [...iframes].forEach((iframe) => {
                // eslint-disable-next-line no-param-reassign
                iframe.style.display = 'none';
            });
        }
    }, [isPrintMode]);

    return (
        <PrintProvider value={isPrintMode}>
            {isPrintMode ? <Watermark/> : null}
            {children}
        </PrintProvider>
    );
});

export default PrintContext;
